var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bannerOffer"},[_c('router-link',{attrs:{"to":"/product?Categoria=Instalação%20de%20Ar-condicionado"}},[_c('img',{staticClass:"bannerOffer__image",attrs:{"loading":"lazy","src":require("../../assets/banner-home.png"),"alt":"Instale seu Ar-Condicionado com a Leveros"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }